module.exports = __webpack_public_path__ + "412d5b5f3b96c650043f402ab933d591.svg";